import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchJson, postJson } from '../lib/api';

export interface PipelineStage {
  id: string;
  name: string;
  order: number;
  color?: string;
}

export interface Pipeline {
  id: string;
  name: string;
  isDefault?: boolean;
  stages: PipelineStage[];
  createdAt: string;
  updatedAt: string;
}

export function usePipelines() {
  return useQuery({
    queryKey: ['pipelines'],
    queryFn: () => fetchJson<Pipeline[]>('/api/pipelines'),
    staleTime: 5 * 60_000,
  });
}

export function useCreatePipeline() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string; stages: { name: string; color?: string }[] }) =>
      postJson<Pipeline>('/api/pipelines', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pipelines'] });
    },
  });
}
